import React from "react";

const Dashboard: React.FC = () => {
  return <h1>Dashboard Page</h1>;
};

export default Dashboard;
